<script setup lang="ts">
import { computed, type Component } from 'vue';

const props = withDefaults(
  defineProps<{
    knobIcon: Component;
    showKnob?: boolean;
    knobValue?: number;
    width?: string;
    height?: string;
  }>(),
  {
    width: '0.7rem',
    height: '0.7rem',
  },
);

const value = computed(() => props.knobValue ?? 0);
</script>

<template>
  <div class="knob-icon">
    <Knob v-if="showKnob" v-model="value" :size="31" readonly :stroke-width="8"> </Knob>
    <component :is="knobIcon" :width="width" :height="height" />
  </div>
</template>

<style lang="scss">
.knob-icon {
  width: 2rem;
  height: 2rem;

  border-radius: 50%;
  background: linear-gradient(
    50deg,
    rgba(16, 153, 253, 0.5) 2%,
    rgba(116, 196, 255, 0.5) 81.35%,
    rgba(116, 196, 255, 0.5) 81.35%
  );
  box-shadow: 0 1.62px 5.995px 0 #1099fd;
  display: flex;

  justify-content: center;
  align-items: center;
  position: relative;

  @include responsive(
    margin-right,
    (
      default: 0.75rem,
      wide: 0.875rem,
      ultrawide: 1rem,
    )
  );

  .p-knob-text {
    display: none;
  }

  > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: none !important;
  }
}
</style>
